import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Data } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { Inject, Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpLink } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

import { ToastColorEnum } from '../../../shared/toast/enums';
import { ToastService } from '../../../shared/toast/services/toast.service';

@Injectable({
    providedIn: 'root',
})

export class GqlService {
    constructor(
        private readonly apollo: Apollo,
        private readonly httpLink: HttpLink,
        private readonly toastService: ToastService,
        @Inject('OAuthModel') private readonly oAuthModel,
        @Inject('environment') private readonly environment,
    ) {
        const errorLink = this.handleOnError();
        const httpLinked = this.httpLink.create({ uri: this.environment.uri });
        const httpLinkWithErrorHandling = ApolloLink.from([ errorLink, httpLinked ]);

        this.apollo.create({
            cache: new InMemoryCache(),
            link: httpLinkWithErrorHandling,
        });
    }

    public query({ query }): Observable<Data> {
        return this.apollo.watchQuery({
            query,
            fetchPolicy: 'network-only',
            context: {
                headers: new HttpHeaders().set('Authorization', `Bearer ${ this.oAuthModel.data.accessToken || '' }`),
            },
        }).valueChanges.pipe(
            map(({ data }) =>
                data[Object.keys(data)[0]]));
    }

    public mutation({ mutation, variables }): Observable<Data> {
        return this.apollo.mutate({ mutation, variables }).pipe(
            map(({ data }) =>
                data[Object.keys(data)[0]]));
    }

    private handleOnError() {
        return onError(({ graphQLErrors, networkError }) => {
            console.log(graphQLErrors, networkError);

            if (graphQLErrors) {
                graphQLErrors.map(({ message }) => this.toastService.open({
                    message,
                    color: ToastColorEnum.danger,
                }));
            }

            if (networkError) {
                this.toastService.open({
                    title: 'Gql network error',
                    color: ToastColorEnum.danger,
                    message: (networkError as any).error._errors ?
                        networkError.message :
                        `<strong>${networkError.name}</strong>: ${(networkError as any).statusText}`,
                    description: (networkError as any).error._errors ?
                        (networkError as any).error._errors[0].message :
                        networkError.message,
                });
            }
        });
    }
}
